


















































import PagePopup from '@/components/popup/page/PagePopup.vue'
import Translation from '@/mixins/Translation'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import FooterButton from '@/components/FooterButton.vue'
import FlightPaperPlaneWithConfetti from '@/components/FlightPaperPlaneWithConfetti.vue'
import addJosaIga from '@/filters/add-josa-iga'

@Component({
  components: {
    FlightPaperPlaneWithConfetti,
    FooterButton,
    PagePopup,
  },
  filters: {
    addJosaIga,
  },
})

export default class IssueDonePopup extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) isOpen: boolean
  @Prop({default: () => ([]), type: Array}) contactToTextList: any[]
  @Prop({default: '', type: String}) invoiceName: string

  invoiceTitle: string = ''

  get clientContactListString(): string {
    return this.contactToTextList.filter((m) => m).join('와 ')
  }

  @Watch('isOpen')
  __isOpen(value) {
    if(value) {
      this.invoiceTitle = this.invoiceName
    }
  }

  onClickComplete() {
    this.$emit('complete')
  }
}
